export default __webpack_public_path__ + "afb0b265a70d7bf2c66b4a185a490149.png";